import React, { useContext } from 'react';
import { useHistory } from 'react-router';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import { PAYMENT_PAGE_EVENTS } from 'Utilities/analytics/analyticsPaymentPage';

import { FiguresBox } from '../components/FiguresBox/FiguresBox';
import FinanceApplicable from '../components/FiguresBox/FinanceApplicable/FinanceApplicable';
import NoFinanceApplicable from '../components/FiguresBox/NoFinanceApplicable/NoFinanceApplicable';
import LocalTexts from '../Payments.text.json';
import { PaymentContext } from '../PaymentsContext';

import styles from './PaymentSuccessful.scss';

const LocalT = new MDText(LocalTexts.payments.successView);

const PaymentSuccessful = () => {
  const { paymentState: { accountNumber, financingAmount } } = useContext(PaymentContext);

  const history = useHistory();

  return (
    <div>
      <FiguresBox
        buttons={
          <>
            <Button
              fullWidth
              icon="chevron"
              label={`${LocalT.translate('button')}`}
              onClick={() => {
                history.push('/account');
                PAYMENT_PAGE_EVENTS.VEHICLE_PAYMENT_ACCOUNT_BUTTON_CLICKED({
                  buttonLabel: `${LocalT.translate('button')}`,
                });
              }}
              variant="secondary"
            />
          </>
        }
        content={
          <>
            {financingAmount ? (
              <>
                <FinanceApplicable
                  financingAmountText={`${LocalT.translate('financeApplicable.financingAmountText')}`}
                  sellerAmountText={`${LocalT.translate('financeApplicable.sellerAmountText', { accountNumber })}`}
                />
                <p className={styles.financeTimeToProcessText}>
                  {LocalT.translate('financeTimeToProcess')}
                </p>
                <p className={styles.financeTimeToProcessText2}>
                  {LocalT.translate('financeTimeToProcess2')}
                </p>
              </>
            ) : (
              <NoFinanceApplicable
                text={`${LocalT.translate('noFinanceApplicable.text', { accountNumber })}`}
              />
            )}
          </>
        }
        icon="success"
        subtitle={`${LocalT.translate('subText')}`}
        title={`${LocalT.translate('title')}`}
      />
    </div>
  );
};

export { PaymentSuccessful };
